import { Component } from 'react';
import { connect } from 'react-redux';

import { bindActionCreators, Dispatch } from 'redux';
import { SetLayoutAction, setLayoutAction } from 'store/actions/layoutActions';
import { OpenModal, PortType, RootState, UserType } from 'types';
import { MapControlsInterface } from 'types/functions';
import { userTypeForPort } from 'utils/permission';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

interface UserProps {
    user: UserType;
    port: PortType;
    mapControls: MapControlsInterface;

    //unused props
    openModelFunction: OpenModal;

    setLayoutAction: SetLayoutAction;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface UserState {}

class User extends Component<UserProps, UserState> {
    constructor(props: UserProps) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <>
                <div className={twclsx('top-3', 'text-black', 'z-30', 'right-4', 'fixed', 'flex', 'flex-col')}>
                    <div
                        onClick={() => {
                            this.props.mapControls.chart?.hideTooltips();

                            this.props.setLayoutAction([
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'system',
                                        section: 'system',
                                        state: true,
                                    },
                                },
                            ]);
                        }}
                        className="flex gap-2 items-center cursor-pointer"
                    >
                        <div>
                            <div className="flex gap-2 items-center text-primary-text">
                                <div>
                                    {this.props.user.first_name} {this.props.user.last_name}
                                </div>
                                <div> - {this.props.port.name}</div>
                            </div>
                            <div className="text-sm h-3 leading-3 text-gray-500">
                                {translate(userTypeForPort(this.props.user, this.props.port.id))}
                            </div>
                        </div>
                        <div className="rounded-full w-6 h-6 bg-gray-400 text-center flex  align-middle cursor-pointer">
                            <img alt="" className="rounded-full " src="/static/images/user.png"></img>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const userstateToProps = (state: RootState) => ({
    user: state.user.user,
    port: state.port.port,
    mapControls: state.map.mapControls,

    openModelFunction: state.layout.openModelFunction,
});

const userDispatchToProps = (dispatch: Dispatch) => ({
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(userstateToProps, userDispatchToProps)(User);
